import React from 'react';
import { Link } from 'gatsby';

const links = [
  ['/', 'Главная'],
  ['/gift/bouquet-of-the-month/', 'Букет месяца'],
  ['/blog/tag/care/', 'Уход за букетом'],
  ['/blog/', 'Блог'],
  ['/gifts/', 'Цветочные подарки'],
  ['/promo/', 'Акции'],
  ['/decor/', 'Декор'],
  ['/workshops/', 'Мастер-классы'],
  ['/portfolio/', 'Портфолио'],
  ['/payment-and-delivery/', 'Оплата и доставка'],
  ['/contacts/', 'Контакты'],
];

export function Footer() {
  return (
    <footer className="section" style={{ background: '#f3f3f3' }}>
      <div className="container">
        {links.map(([href, caption]) => (
          <div key={href}>
            <Link to={href}>{caption}</Link>
          </div>
        ))}
      </div>
    </footer>
  );
}
